import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

const CDFAReportConfig = {
    auth: [...authRoles.admin],
    routes: [{ exact: true, path: '/cdfa-report', component: FuseLoadable({ loader: () => import('./ViewCDFAReportApp') }) }],
};

export default CDFAReportConfig;
